export class ModuleTopmostTracking {
    // staff
    module;

    constructor() {
        this.init();
    }

    init() {
        this.module = $('.md-topmost');

        if (!this.module.length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        this.module.on('click', 'a.lnk', (e) => {
            const button = $(e.target);

            const data = {
                bloque: this.getTabText(button),
                event: 'destacados_programa'
            };

            if (this.isNews(button)) {
                data.noticia = this.getText(button);
            } else {
                data.programa = this.getText(button);
            }

            this.sendGTMEvent(data);
        });
    }

    sendGTMEvent(data) {
        if (window.dataLayer) {
            console.debug('Topmost event track ', data);
            window.dataLayer.push(data);
        }
    }

    // auxiliary
    getTabText(button) {
        const id = button.closest('.navigation-tabs__pane--active').prop('id');

        return this.module.find('a[href="#' + id + '"]').text() || '';
    }

    getText(button) {
        return button.text() || '';
    }

    isNews(button) {
        return !button.closest('.kicker').length;
    }
}
